import { MultiLingualStylesheet } from '../interfaces/Stylesheet';
import { cdn } from '../services/AxiosService';
import { CdnRepository } from './interfaces/CdnRepository';

export default class CdnRepositoryRemote implements CdnRepository {
  public getStylesheet(subscriptionId: string): Promise<MultiLingualStylesheet> {
    return cdn.get<MultiLingualStylesheet>(`/stylesheets/${subscriptionId}.json`);
  }
}
